export const ROBOKASSA_PAYMENT_FROM_PROFILE_PAGE = "profile/payment";
